module.exports = __webpack_public_path__ + "static/img/8.8dd22f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/eng/8.png
// module id = Qz1O
// module chunks = 0